
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5828',
  depVersions: {
  "data-privacy-request-ui": "static-1.5828",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9963",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8341",
  "hub-http-shared-msw-handlers": "static-1.10626",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11798",
  "I18n": "static-7.1674",
  "jasmine-runner": "static-1.6759",
  "quartz": "static-1.7465",
  "react-dlb": "static-1.89",
  "rpc-client-utils": "static-1.4974",
  "ui-components-test-utils": "static-1.5935",
  "UIComponents": "static-3.8744",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.94",
  "foundations-assets": "static-1.5193",
  "foundations-components": "static-1.8502",
  "foundations-components-test-utils": "static-1.5985",
  "foundations-theming": "static-1.4785",
  "hub-http": "static-1.6521",
  "quartz-config": "static-1.1243",
  "quartz-core": "static-1.6684",
  "quartz-routing": "static-1.895",
  "quick-fetch": "static-1.4133",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-rhumb": "static-1.17030",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11455",
  "usage-tracker": "static-1.7637",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-core": "static-1.7487",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3625",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3742",
  "quartz-webpack": "static-1.3689",
  "bend-plugin-quartz-routing": "static-1.543",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.89",
  "HeadJS": "static-2.798",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3452",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4299",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "react-utils": "static-2.5560",
  "StyleGuideUI": "static-3.502",
  "jasmine": "static-4.4621",
  "bend-plugin-chirp-manifest": "static-1.385",
  "chirp-fetch": "static-1.2203",
  "HubStyle": "static-2.12105",
  "ui-addon-draggable": "static-3.5069",
  "cssUtils": "static-1.930",
  "hs-story-utils": "static-1.9733",
  "icons": "static-2.684",
  "react-create-root-preference": "static-1.71",
  "react-select-plus": "static-1.113",
  "react-virtualized": "static-2.107",
  "ui-images": "static-2.1250",
  "bend-plugin-foundations-components": "static-1.4771",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2501",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2658",
  "ui-fonts": "static-1.1060",
  "foundations-components-legacy": "static-1.1527",
  "bend-plugin-foundations-theming": "static-1.3268",
  "foundations-theming-base": "static-1.3770",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.299",
  "opentelemetry-fe-types": "static-1.80",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.880",
  "hubspotter-http": "static-1.4868",
  "mobile-manifest-mixins": "static-1.577",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.455",
  "quartz-auth": "static-1.1140",
  "quartz-head": "static-1.1130",
  "quartz-i18n": "static-1.1140",
  "quartz-test": "static-1.1140",
  "quartz-tracking": "static-1.844",
  "trellis-components": "static-1.2677",
  "usage-tracker-container": "static-1.7627",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3444",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "sassPrefix": "static-1.200",
  "stylex-utils": "static-1.141",
  "trellis-theming": "static-1.1282",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10624",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5828",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9963",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8341",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10626",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11798",
  "I18n": "/I18n/static-7.1674",
  "jasmine-runner": "/jasmine-runner/static-1.6759",
  "quartz": "/quartz/static-1.7465",
  "react-dlb": "/react-dlb/static-1.89",
  "rpc-client-utils": "/rpc-client-utils/static-1.4974",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5935",
  "UIComponents": "/UIComponents/static-3.8744",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "foundations-assets": "/foundations-assets/static-1.5193",
  "foundations-components": "/foundations-components/static-1.8502",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5985",
  "foundations-theming": "/foundations-theming/static-1.4785",
  "hub-http": "/hub-http/static-1.6521",
  "quartz-config": "/quartz-config/static-1.1243",
  "quartz-core": "/quartz-core/static-1.6684",
  "quartz-routing": "/quartz-routing/static-1.895",
  "quick-fetch": "/quick-fetch/static-1.4133",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-rhumb": "/react-rhumb/static-1.17030",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11455",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3625",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3742",
  "quartz-webpack": "/quartz-webpack/static-1.3689",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.543",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.89",
  "HeadJS": "/HeadJS/static-2.798",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3452",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4299",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "react-utils": "/react-utils/static-2.5560",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "jasmine": "/jasmine/static-4.4621",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.385",
  "chirp-fetch": "/chirp-fetch/static-1.2203",
  "HubStyle": "/HubStyle/static-2.12105",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5069",
  "cssUtils": "/cssUtils/static-1.930",
  "hs-story-utils": "/hs-story-utils/static-1.9733",
  "icons": "/icons/static-2.684",
  "react-create-root-preference": "/react-create-root-preference/static-1.71",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-virtualized": "/react-virtualized/static-2.107",
  "ui-images": "/ui-images/static-2.1250",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4771",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2501",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2658",
  "ui-fonts": "/ui-fonts/static-1.1060",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1527",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3268",
  "foundations-theming-base": "/foundations-theming-base/static-1.3770",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.299",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.80",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.880",
  "hubspotter-http": "/hubspotter-http/static-1.4868",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.577",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.455",
  "quartz-auth": "/quartz-auth/static-1.1140",
  "quartz-head": "/quartz-head/static-1.1130",
  "quartz-i18n": "/quartz-i18n/static-1.1140",
  "quartz-test": "/quartz-test/static-1.1140",
  "quartz-tracking": "/quartz-tracking/static-1.844",
  "trellis-components": "/trellis-components/static-1.2677",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "sassPrefix": "/sassPrefix/static-1.200",
  "stylex-utils": "/stylex-utils/static-1.141",
  "trellis-theming": "/trellis-theming/static-1.1282",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10624",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
